import messages from './messages';

const slash = /\//g;

const getCategoryTitle = (category, hasLocalNews, intl) => category
  && category.title
  && (hasLocalNews
    ? category.title
    : intl
      .formatMessage(
        messages[
          `category.${category.path.replace(slash, '.')}`
        ],
      )
  );

export default getCategoryTitle;
